'use strict';

angular.module('app.manualPosts')
    .controller('findPostCtrl', ['$scope', '$modal', 'adminService', 'manualPostsService', '$state', '$rootScope', '$location',
        function ($scope, $modal, adminService, manualPostsService, $state, $rootScope, $location) {
            var me = this;
            var isFramed = $scope.isFramed;
            
            $scope.currentPage = 1;
            $scope.pageSize = 25;


            $scope.pagination = function(){
                $scope.pages = adminService.pagination($scope.number, $scope.pageSize);
            };


            var searchPost = function (url) {
                if (url) {
                    var eUrl = encodeURIComponent(url);
                    //me.url = undefined;
                    manualPostsService.searchPostByURL(eUrl, true) 
                        .then(function(response) {
                            me.postResult = response.data;
                            angular.forEach(me.postResult, function(item) {
                                item.title  = item.title.replace(/\uFFFD/g, '');
                            });
                        }, function(response) {
                            me.postResult = [];
                        })
                }
            };

            var goToPostOverview = function (post) {
                if (isFramed) {
                    window.parent.postMessage(
                        {
                            page: 'post_page',
                            details: {
                                url: post.url,
                                relative_path: post.relativepath,
                                influencer_id: post.blog_id
                            }
                        },
                        '*'
                    );
                }
                else {
                    $rootScope.previousPagePost = $location.absUrl();
                    if (post.platform === 1) {
                        $state.transitionTo('home.blogPostOverview', {url: post.url, relativepath: post.relativepath}, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    } 
                    else if (post.platform === 2) {
                        $state.transitionTo('home.instagramPostOverview', {url: post.url, relativepath: post.relativepath}, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    } 
                    else if (post.platform === 6) {
                        $state.transitionTo('home.youtubePostOverview', {url: post.url, relativepath: post.relativepath}, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    }
                    else if (post.platform === 7) {
                        $state.transitionTo('home.facebookPostOverview', {url: post.url, relativepath: post.relativepath}, {
                            reload: false,
                            inherit: true,
                            notify: true
                        });
                    }
                }
            };

            var clear = function () {
                me.url = undefined;
                me.postResult = undefined;
            };

            (function(){
                me.searchPost = searchPost;
                me.goToPostOverview = goToPostOverview;
                me.clear = clear;
            })();

}])